import * as _ from "lodash";
import * as React from "react";
import {Subscription} from "rxjs";
import {filter} from "rxjs/operators";
import {DataTable} from "@bizform/primereact/components/datatable/DataTable";
import {Column} from "@bizform/primereact/components/column/Column";
import {OverlayPanel} from "@bizform/primereact/components/overlaypanel/OverlayPanel";
import {
    ComponentCategory,
    ComponentElementManifest,
    ComponentElementProperty
} from "@bizform/type/model/component_element/ComponentElementManifest.model";
import {Static} from "@bizform/type/decorator/Static.decorator";
import {
    BaseStateModel,
    ComponentElement,
    ComponentElementStatic
} from "@bizform/type/model/component_element/ComponentElement.model";
import {DefaultLayoutId} from "@bizform/type/model/component_element/DefaultLayoutId.model";
import {PluginType} from "@bizform/type/model/model/Plugin.model";
import {DomAttribute} from "@bizform/type/model/dom/DomAttribute.model";
import {
    CallGridAction,
    DoGridAction,
    DoRetrieve,
    GridAutoSaveKeyConstant,
    GridClientPagingKeyConstant,
    GridClientPagingSizeKeyConstant,
    GridIdKeyConstant,
    GridLinkIdKeyConstant,
    GridRetrieveKeyConstant,
    GridValidationKeyConstant
} from "@bizform/type/model/component_element/manifest_constant/Grid.constant";
import {WindowKey} from "@bizform/type/model/model/WindowKey.model";
import {GridSubject, GridSubjectType, NotificationSubjectType} from "@bizform/type/model/model/Subject.model";
import {
    GridContainerRole,
    GridContextMenu,
    GridRepeatedFiltersInformation,
    GridSpecialColumn,
    GridTableColumnsInformation
} from "@bizform/type/model/form/Grid.model";
import {GridFilters} from "@bizform/type/model/rest_api/Grid.model";
import {SortOption} from "@bizform/type/model/rest_api/_BaseRestApi.model";
import {DataType} from "@bizform/type/model/model/DataType.model";
import {GridTableCheckBOx} from "@bizform/type/model/data_set/LookUp.model";
import {
    BlockHandler,
    ComponentElementClass,
    EventResize,
    FormDataSchemaService,
    FormStateService,
    FormValidationService,
    GridActionService,
    GridDataService,
    GridSchemaService,
    ModalHandler,
    ReactComponentElementInit,
    RelationShipDataService,
    SubjectService
} from "@bizform/core/dist/js/bizflow/core.min";
import {
    BrowserHelper,
    ComponentHelper,
    DateHelper,
    Debug,
    DomHelper,
    FunctionHelper,
    ObjectHelper,
    StringHelper
} from "@bizform/helper/dist/js/bizflow/helper.min";
import {AbstractComponentElement} from "../bf_component/AbstractComponentElement";
import {GridHelper} from "./helper/Grid.helper";
import {Filter} from "./helper/Filter";
import {UserUI} from "../misc/addon/UserUI";
import {ContextHelper} from "./helper/Context.helper";


type Props =  {
};

type State = BaseStateModel & {
    [GridIdKeyConstant]?: string;
    [GridClientPagingKeyConstant]?: boolean;
    [GridClientPagingSizeKeyConstant]?: boolean;
    autoLoad?: boolean;
    value?: any[];
    header?: boolean;
    footer?: boolean;
    action?: boolean;
    actionWidth?: any;
    checkbox?: string;
    paginator?: boolean;
    alwaysShowPaginator?: boolean;
    paginatorPosition?: string;
    rows?: number;
    pageNo?: number;
    pageLinkSize?: number;
    sortMode?: string;
    sortField?: string;
    sortOrder?: string;
    multiSortMeta?: any[];
    selection?: any;
    resizableColumns?: boolean;
    columnResizeMode?: string;
    reload?: boolean;
    cFilter?: boolean;
    filter?: boolean;
    overlay?: boolean;
    autoLayout?: boolean;
    autoResize?: boolean;
    tbodyWidth?: any;
    fixedHeader?: any;
    emptyMessage?: string;
    totalRecords?: number;
    columns?: Array<GridTableColumnsInformation>;
    click?: string;
    state?: string;
    context?: Array<GridContextMenu>;
    inlineContext?: any;
    selectionAction?: any;
    deselectionAction?: any;
    containerClassName?: string;
    containerStyle?: object;
    tableStyle?: object;
    tableClassName?: string;
    filterClassName?: string;
    filterStyle?: object;
    headerClassName?: string;
    headerStyle?: object;
    footerClassName?: string;
    footerStyle?: object;
    fileClassName?: string;
    fileStyle?: object;
    columnHeaderStyle?: object;
    columnHeaderClassName?: string;
    columnBodyStyle?: object;
    columnBodyClassName?: string;
    onSort?(e: {sortField: string, sortOrder: number, multiSortMeta: any}): void;
    onPage?(e: {first: number, rows: number}): void;
    onFilter?(filters: any[]): void;
    onRowSelect?(e: {originalEvent: Event, data: any, type: string}): void;
    onRowUnselect?(e: {originalEvent: Event, data: any, type: string}): void;
};

/**
 * Grid Action Container
 *
 * @since 0.0.1
 * @author Heungsoo Ham
 * @class
 */
@ComponentElementClass()
@Static<ComponentElementStatic<string>>()
export class BfGridTableContainer extends AbstractComponentElement<Props, State> {
    static readonly pluginType: string = PluginType.GRIDHANDLER;

    /* manifest */
    static readonly componentElementManifest: ComponentElementManifest = {
        uniqueId: "_55bW7m4pXeNXX5DLTVO82xaMKB_NWLF",
        category: ComponentCategory.HANDLER,
        defaultLayoutId: DefaultLayoutId.ONLYCOMPONENTELEMENT,
        label: "Table Container",
        description: "Table Container",
        icon: "",
        property: null
    };

    setProperty(property: ComponentElementProperty) {
        try {
            FormValidationService.regValidationHandler((this as any).___props);
            const newState = ComponentHelper.createStateWithProperties<State, null>(
                property,
                this);
            this._clientPagingSize = GridHelper.setClientPaging(newState);
            if (newState[GridAutoSaveKeyConstant]) {
                GridActionService.regAutoSave(this.applicationId, this.formId, newState[GridIdKeyConstant], newState[GridLinkIdKeyConstant], this._elementId);
            }
            if (this._forcedFilter === false) {
                this._forcedFilter = true;
            }
            if (newState.cFilter !== false) {
                newState.cFilter = true;
            }
            if (newState.filter || newState.cFilter) {
                this._filterField = null;
                this._filterStructure(newState);
            }
            if (newState.fixedHeader) {
                newState.fixedHeader = parseInt(newState.fixedHeader);
                if (newState.fixedHeader > 0 && !window[WindowKey.DESIGNMODE]) {
                    newState.autoResize = false;
                } else {
                    newState.fixedHeader = 0;
                }
            }
            if (newState.actionWidth) {
                newState.actionWidth = parseInt(newState.actionWidth);
                if (!newState.actionWidth || newState.actionWidth === 0) {
                    newState.actionWidth = 0;
                }
            }
            this._dSortOrder = newState.sortOrder === "asc" ? 1 : -1;
            GridSchemaService.setRetrieve(this._elementId, newState[GridRetrieveKeyConstant]);
            this._columns = null;
            this._hasFile = "";
            this._hasFileUpload = "";
            if (newState.columns && newState.columns.length) {
                this._columns = [];
                let action = false;
                for (const k in newState.columns) {
                    if (newState.columns[k].usable) {
                        if (newState.columns[k].special === GridSpecialColumn.CHECKBOX && newState.checkbox === GridTableCheckBOx.NONE) {
                            continue;
                        }
                        if (newState.columns[k].special === GridSpecialColumn.ACTION && !newState.action) {
                            continue;
                        }
                        if (newState.columns[k].special === GridSpecialColumn.ACTION && newState.action) {
                            action = true;
                        }
                        this._columns.push(newState.columns[k]);
                        const eId = newState.columns[k].entityId + ",";
                        if (newState.columns[k].type === DataType.FILE) {
                            this._hasFile += eId;
                            if (newState.columns[k].editable) {
                                this._hasFileUpload += eId;
                            }
                        }
                        if (!this._hasEdit && newState.columns[k].editable) {
                            this._hasEdit = true;
                        }
                    }
                }
                if (newState.action && !action) {
                    newState.columns.push({special: GridSpecialColumn.ACTION, usable: true});
                    this._columns.push(newState.columns[newState.columns.length - 1]);
                }
                this._hasFile = this._hasFile.replace(/,$/, "");
                this._hasFileUpload = this._hasFileUpload.replace(/,$/, "");
            }
            this._initInlineFilter = this._initInlineFilter ? false : true;
            this._onSort(null, newState);
            this.setState(newState);
        } catch (e) {
            Debug.console.error("setProperty", e);
        }
    }

    emitFormState(value: string, e?: MouseEvent): void {
    }

    emitHasContainerKey(): void {
    }

    noDisplayInheritance() {
    }

    @ReactComponentElementInit(BfGridTableContainer)
    static init(): ComponentElement<string> {
        return;
    }

    initDone(): void {
        if (!this._gridSubject && !window[WindowKey.DESIGNMODE] && !window[WindowKey.VERSIONMODE]) {
            this._elementId = StringHelper.elementId(this.elementId);
            this._gridSubject = SubjectService.gridSubject.pipe(
                filter((data: GridSubject) =>
                    this.state &&
                    (
                        (data.type === GridSubjectType.RELOAD && data.containerElementId === this._elementId) ||
                        (data.formId === this.formId && data[GridIdKeyConstant] === this.state[GridIdKeyConstant] &&
                            (
                                (data.type === GridSubjectType.CALLACTION && (
                                    (data.value === CallGridAction.EDIT && data.containerElementId === this.elementId) ||
                                    (data.value === "Run" + DoGridAction.CANCEL && (data.globalIndex + data.containerElementId) === this.elementId) ||
                                    (["Run" + DoGridAction.ADD, "Run" + DoGridAction.RELOAD, DoRetrieve.RELOADRETRIEVE].indexOf(data.value) > -1)
                                )) ||
                                (data.type === GridSubjectType.REQRELOAD && this.elementId !== data.containerElementId)
                            )
                        )
                    )
                )
            ).subscribe(
                (data: GridSubject) => {
                    if (this.displayMode) {
                        if (data.type === GridSubjectType.RELOAD) {
                            if (!data.value.page) {
                                this._onReload();
                                return;
                            }
                            if (data.value.forced) {
                                this._pageNo = null;
                            }
                            this.setPage(data.value.page);
                            return;
                        }
                        if (data.value === CallGridAction.EDIT) {
                            this._inlineEditor(data.pk).then();
                            return;
                        }
                        if (data.value === "Run" + DoGridAction.CANCEL) {
                            this._inlineEditor(null, null, true).then();
                            return;
                        }
                        const retrieve = this.state[GridRetrieveKeyConstant] === true;
                        if (data.type === GridSubjectType.REQRELOAD && data.uniqueId) {
                            if (data.uniqueId === this._searchId) {
                                return;
                            }
                        }
                        if (data.type === GridSubjectType.CALLACTION && data[GridLinkIdKeyConstant] === this.state[GridLinkIdKeyConstant]) {
                            if (data.value === DoRetrieve.RELOADRETRIEVE && data.containerElementId === this._elementId) {
                                this._onReload();
                                return;
                            }
                            if (data.containerRole !== GridContainerRole.SEARCH && retrieve && ((retrieve && data.value === "Run" + DoGridAction.RELOAD && data.containerElementId !== this._elementId) || (data.value !== DoRetrieve.RELOADRETRIEVE && data.containerElementId !== this._elementId))) {
                                GridDataService.checkEpk(data.applicationId, data.formId, data[GridIdKeyConstant], data[GridLinkIdKeyConstant], this._elementId, null);
                                return;
                            }
                            if (data.value !== DoRetrieve.RELOADRETRIEVE && data.containerElementId !== this._elementId) {
                                if ((retrieve && !data.retrieve) || (!retrieve && data.retrieve)) {
                                    return;
                                }
                            }
                            if (data.value !== "Run" + DoGridAction.RELOAD || data.containerRole === GridContainerRole.SEARCH || data.containerElementId === this._elementId || (this._hasPk !== true && GridDataService.hasPk(this.formId, data[GridIdKeyConstant], data[GridLinkIdKeyConstant], data.containerElementId, this.state[GridLinkIdKeyConstant], this._elementId, data.value))) {
                                this._pageNo = null;
                                const pageNo = data.value === "Run" + DoGridAction.RELOAD ? this.state.pageNo : 1;
                                const searchId = (data.value === "Run" + DoGridAction.RELOAD && data.uniqueId) ? data.uniqueId : null;
                                this.setPage(pageNo, data.containerRole !== GridContainerRole.SEARCH, false, searchId).then();
                            }
                        } else if (data.containerRole !== GridContainerRole.SEARCH && (data.value === "Run" + DoGridAction.RELOAD || data.value === "Run" + DoGridAction.ADD || data.type === GridSubjectType.REQRELOAD)) {
                            if (data.containerElementId !== this._elementId && !retrieve) {
                                if (this._hasPk !== true && GridDataService.hasPk(this.formId, data[GridIdKeyConstant], data[GridLinkIdKeyConstant], data.containerElementId, this.state[GridLinkIdKeyConstant], this._elementId, data.value)) {
                                    this._hasPk = true;
                                    this._onReload(true);
                                }
                            }
                        }
                    }
                }
            );
        }
    }

    destroy(): void {
        FormValidationService.removeValidationHandler((this as any).___props);
        this.destroyDone();
    }

    destroyDone(): void {
    }

    /* for React */
    props: Props;
    state: State;

    private _pageNo: number;
    private _table: any;
    private _dWrapper: HTMLElement;
    private _dHeader: HTMLElement;
    private _dFooter: HTMLElement;
    private _dPaginator: HTMLElement;
    private _elementId: string;
    private _gridSubject: Subscription;
    private _filters: Array<GridFilters>;
    private _filter: any;
    private _cFilter: any;
    private _directDom: HTMLElement;
    private _th: Array<HTMLElement>;
    private _style: HTMLStyleElement;
    private _hasPk: boolean;
    private _forcedFilter: boolean;
    private _filterField: Array<GridRepeatedFiltersInformation>;
    private _list: any;
    private _listSize: number;
    private readonly _fakeDom: Array<HTMLElement>;
    private readonly _fakeInlineDom: Array<HTMLElement>;
    private _dSortOrder: number;
    private _columns: Array<GridTableColumnsInformation>;
    private readonly _t: string;
    private readonly _reg: RegExp;
    private _hasEdit: boolean;
    private _hasFile: string;
    private _hasFileUpload: string;
    private _fileList: { [key: string]: any };
    private _fakeFileList: HTMLElement;
    private _fakeFileUpload: HTMLElement;
    private _fakeSign: HTMLElement;
    private _preFileList: string;
    private _regResize: boolean;
    private _offsetHeight: number;
    private _context: any;
    private _contextContainer: HTMLElement;
    private _clientPagingSize?: number;
    private readonly _contextList: {
        [key: string]: Array<HTMLElement>;
    };
    private _reData?: boolean;
    private _bindData: {
        [rowIndex: number]: {
            [columnIndex: number]: any;
        };
    };
    private _searchId: string;
    private _inLinePk: string;
    private _inLinePkDom: HTMLElement;
    private _nextPk: string;
    private _savedInlinePk: boolean;
    private _savedAuto: boolean;
    private _inLineTarget: HTMLElement;
    private _startInlineEditor: boolean;
    private _altKey: boolean;
    private _inlineEditComponents: any;
    private _initInlineFilter: boolean;
    private _fromSort: boolean;
    private _components: {
        [key: string]: HTMLElement;
    };
    private _componentRef: HTMLElement;
    private _preColumnFilterIndex: number;
    private _value: number;

    constructor(props?: Props) {
        super(props);
        this.state = {};
        this._fakeDom = [];
        this._fakeInlineDom = [];
        this._t = (1000).toLocaleString().charAt(1);
        this._reg = /\B(?=(\d{3})+(?!\d))/g;
        this._contextList = {};

        this._setTableRef = this._setTableRef.bind(this);
        this._setFilterRef = this._setFilterRef.bind(this);
        this._setCFilterRef = this._setCFilterRef.bind(this);
        this._setFileList = this._setFileList.bind(this);
        this._setFakeFileList = this._setFakeFileList.bind(this);
        this._setFakeFileUpload = this._setFakeFileUpload.bind(this);
        this._setFakeSign = this._setFakeSign.bind(this);
        this._setContextRef = this._setContextRef.bind(this);
        this._setComponentRef = this._setComponentRef.bind(this);
        this.setPage = this.setPage.bind(this);
        this.onPage = this.onPage.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this._onSort = this._onSort.bind(this);
        this._onRowSelect = this._onRowSelect.bind(this);
        this._onRowUnselect = this._onRowUnselect.bind(this);
        this._onReload = this._onReload.bind(this);
        this._onFilter = this._onFilter.bind(this);
        this._onFilterError = this._onFilterError.bind(this);
        this._onSelectionChange = this._onSelectionChange.bind(this);
        this._onOpenOverlay = this._onOpenOverlay.bind(this);
        this._onClick = this._onClick.bind(this);
        this._onEnter = this._onEnter.bind(this);
        this._onContextMenu = this._onContextMenu.bind(this);
        this._onInlineContextMenu = this._onInlineContextMenu.bind(this);
        this._callbackList = this._callbackList.bind(this);
        this._makeColumns = this._makeColumns.bind(this);
        this._bodyTemplate = this._bodyTemplate.bind(this);
        this._makeInlineEditComponents = this._makeInlineEditComponents.bind(this);
        this._autoResize = this._autoResize.bind(this);
        this._sign = this._sign.bind(this);
        this._overlay = this._overlay.bind(this);
        this._doUnload = this._doUnload.bind(this);
        this._onColumnFilter = this._onColumnFilter.bind(this);
        this._resizeListener = this._resizeListener.bind(this);
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (this.state[GridIdKeyConstant] && !this.state.pageNo) {
            this.state.pageNo = 1;
            if (this.state[GridRetrieveKeyConstant] !== true && this.state.autoLoad !== false) {
                this.setPage(1, true).then();
            } else {
                this._pageNo = 1;
            }
        }
        if (this.state.value && this.state.value.length) {
            this._reData = false;
        }
        if (this._initInlineFilter === false) {
            GridHelper.inlineFilter(this.state.cFilter, this._dWrapper, this._filter, this._columns, this._onColumnFilter);
            this._initInlineFilter = true;
        }
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        Debug.console.error(error, errorInfo);
    }

    componentWillUnmount() {
        if (this._regResize) {
            ModalHandler.removeOpenCallback(this._autoResize);
            this._removeContextList();
        }
        ModalHandler.removeOpenCallback(this._overlay);
        ModalHandler.removeCloseCallback(this._overlay);
    }

    render(): React.ReactNode {
        if (!this.displayMode || !this.state[GridIdKeyConstant]) {
            return null;
        } else {
            const className = "m-0 p-0" + (this.state.containerClassName ? " " + this.state.containerClassName : "");
            const first = this.state.paginator && this.state.pageNo ? (this.state.pageNo - 1) * this.state.rows : 0;
            const columns = this._columns && this._columns.length ? this._columns.map(this._makeColumns) : null;
            const sortField = this.state.sortMode === "single" && this.state.sortField ? this.state.sortField : null;
            const sortOrder = this.state.sortMode === "single" && this.state.sortOrder ? (this.state.sortOrder === "desc" ? -1 : 1) : -1;
            const multiSortMeta = this.state.sortMode === "multiple" ? this.state.multiSortMeta : null;
            const attr = this.state.header ? {
                [DomAttribute.GRIDID]: this.state[GridIdKeyConstant],
                [DomAttribute.GRIDSEARCHCONTAINER]: this._elementId,
                [DomAttribute.GRIDLINKID]: this.state[GridLinkIdKeyConstant]
            } : null;
            let page = null;
            if (this.state.paginator && !this.state.alwaysShowPaginator && (!this.state.totalRecords || this.state.totalRecords <= this.state.rows)) {
            } else {
                page = this.state.paginator ? {
                    paginator: (this.state.paginator && !this.state.alwaysShowPaginator && (!this.state.totalRecords || this.state.totalRecords <= this.state.rows)) ? false : this.state.paginator,
                    paginatorPosition: this.state.paginatorPosition,
                    alwaysShowPaginator: this.state.alwaysShowPaginator,
                    pageLinkSize: this.state.pageLinkSize,
                } : null;
            }
            const value = this._hasEdit && (window[WindowKey.DESIGNMODE] || window[WindowKey.VERSIONMODE]) ? [{index: 0}] : this.state.value;
            this._value = value && value.length ? value.length : 0;
            const tStyle: any = {...this.state.tableStyle};
            if (this.state.tbodyWidth) {
                tStyle.width = this.state.tbodyWidth + "px";
                tStyle.minWidth = this.state.tbodyWidth + "px";
                tStyle.maxWidth = this.state.tbodyWidth + "px";
            }
            if (!this._inlineEditComponents) {
                this._inlineEditComponents = this._hasEdit && !window[WindowKey.DESIGNMODE] && !window[WindowKey.VERSIONMODE] ? <div ref={this._setComponentRef} className="___components d-none">{this._columns.map(this._makeInlineEditComponents)}</div> : null;
            }
            return (
                <React.Fragment>
                    {this._inlineEditComponents}
                    {GridHelper.infoGridContainer(this.parentDom, this.state[GridIdKeyConstant], "Table Container - Header", this.elementId, this.state[GridLinkIdKeyConstant], this.elementId, "Table")}
                    <DataTable
                        {...page}
                        ref={this._setTableRef}
                        key={this.elementId}
                        id={this.elementId}
                        lazy={true}
                        value={value}
                        header={this._header()}
                        footer={this.state.footer ? this._footer() : null}
                        rows={this.state.rows}
                        first={first}
                        totalRecords={this.state.totalRecords ? this.state.totalRecords : 0}
                        emptyMessage={this._columns && this._columns.length ? this.state.emptyMessage : null}
                        sortMode={this.state.sortMode}
                        sortOrder={sortOrder}
                        sortField={sortField}
                        multiSortMeta={multiSortMeta}
                        selectionMode={this.state.checkbox}
                        selection={this.state.selection}
                        resizableColumns={!window[WindowKey.DESIGNMODE] ? this.state.resizableColumns : false}
                        columnResizeMode={this.state.columnResizeMode}
                        autoLayout={this.state.autoLayout}
                        className={className}
                        style={this.state.containerStyle as any}
                        tableClassName={this.state.tableClassName}
                        tableStyle={tStyle}
                        onSort={this._onSort}
                        onPage={this.onPage}
                        onRowSelect={this._onRowSelect}
                        onRowUnselect={this._onRowUnselect}
                        onSelectionChange={this._onSelectionChange}
                        onColumnResizeEnd={this._resizeListener}
                    >
                        {columns}
                    </DataTable>
                    <OverlayPanel
                        key={this._elementId + "_context"}
                        ref={this._setContextRef}
                        showCloseIcon={false}
                        dismissable={true}
                        appendTo={DomHelper.getForOverLayDom()}
                    >
                        <div id={this.elementId + "_context"} className={"m-0 p-0"} {...attr}></div>
                    </OverlayPanel>
                </React.Fragment>
            );
        }
    }

    onSearch(filters?: Array<GridFilters>) {
        if (this._filter && this._filter.hide) {
            this._filter.hide(null);
        }
        this._filters = filters;
        GridHelper.highLightFilter(this._th, filters, this._columns).then();
        this.setPage(1, null, null, null, true).then();
    }

    private _header(): JSX.Element | string {
        if (!this._hasFile && !this._hasFileUpload && !this.state.header && !this.state.action && !this.state.filter && !this.state.reload) {
            return null;
        }
        const f = GridHelper.indicatorGridContainer("Header", true);
        const attr = this.state.header ? {
            [DomAttribute.GRIDID]: this.state[GridIdKeyConstant],
            [DomAttribute.CONTAINER]: "header",
            [DomAttribute.GRIDSEARCHCONTAINER]: this._elementId,
            [DomAttribute.GRIDLINKID]: this.state[GridLinkIdKeyConstant],
            [DomAttribute.GRIDROOT]: this.elementId + "-direct",
        } : null;
        const attr3 = {
            [DomAttribute.GRIDID]: this.state[GridIdKeyConstant],
            [DomAttribute.GRIDSEARCHCONTAINER]: this._elementId,
            [DomAttribute.GRIDLINKID]: this.state[GridLinkIdKeyConstant]
        };
        let action = null;
        let inlineEditor = null;
        if (this.state.action && (window[WindowKey.DESIGNMODE] || window[WindowKey.VERSIONMODE])) {
            const a = GridHelper.indicatorGridContainer("Column Action (Read Mode)", false);
            const attr2 = {
                [DomAttribute.CONTAINER]: "action"
            };
            action = (
                <div className="m-0 p-0 text-left" style={{"fontWeight": "normal"}}>
                    {a}
                    <div {...attr2}></div>
                </div>
            );
            if (this._hasEdit) {
                const a = GridHelper.indicatorGridContainer("Column Action (Edit Mode)", false);
                const attr2 = {
                    [DomAttribute.CONTAINER]: "inlineAction"
                };
                inlineEditor = (
                    <div className="m-0 p-0 text-left" style={{"fontWeight": "normal"}}>
                        {a}
                        <div {...attr2}></div>
                    </div>
                );
            }
        }
        let fileList = null;
        if (this._hasFile && (window[WindowKey.DESIGNMODE] || window[WindowKey.VERSIONMODE])) {
            const a = GridHelper.indicatorGridContainer("File List (Read" + (this._hasFileUpload ? " Mode / Edit" : "") + " Mode)", false);
            const attr2 = {
                [DomAttribute.CONTAINER]: "fileList",
                [DomAttribute.GRIDEDITID]: this._hasFile
            };
            fileList = (
                <div className="m-0 p-0 text-left" style={{"fontWeight": "normal"}}>
                    {a}
                    <div {...attr2}></div>
                </div>
            );
        } else if (this._hasFile) {
            attr3[DomAttribute.CONTAINER] = "fileList";
            fileList = <div ref={this._setFakeFileList} {...attr3} className="d-none"></div>;
        }
        let fileUpload = null;
        if (this._hasFileUpload && (window[WindowKey.DESIGNMODE] || window[WindowKey.VERSIONMODE])) {
            const a = GridHelper.indicatorGridContainer("File Upload (Edit Mode)", false);
            const attr2 = {
                [DomAttribute.CONTAINER]: "fileUpload",
                [DomAttribute.GRIDEDITID]: this._hasFileUpload
            };
            fileUpload = (
                <div className="m-0 p-0 text-left" style={{"fontWeight": "normal"}}>
                    {a}
                    <div {...attr2}></div>
                </div>
            );
        } else if (this._hasFileUpload) {
            attr3[DomAttribute.CONTAINER] = "fileUpload";
            fileUpload = <div ref={this._setFakeFileUpload} {...attr3} className="d-none"></div>;
        }
        let header;
        const width = this.state.filter && this.state.reload ? "60px" : this.state.filter || this.state.reload ? "30px" : null;
        if (width) {
            const filters = (this.state.filter || this.state.cFilter) && this._filterField && this._filterField.length ? this._makeFilter() : null;
            const filter = this.state.filter && this._filterField && this._filterField.length ? (
                <button key={this.elementId + "_filter"} onClick={this._onFilter} className="p-button p-component p-button-primary p-button-icon-only" style={{width: "28px", height: "28px"}} title="Filter">
                    <span className="fas fa-search p-c p-button-icon-left"></span>
                </button>
            ) : null;
            const reload = this.state.reload ? (
                <div className="p-inputgroup-addon position-absolute" style={{top: "-30px", right: 0}}>
                    {filter}
                    <button key={this.elementId + "_reload"} onClick={this._onReload} className="p-button p-component p-button-secondary p-button-icon-only" style={{width: "28px", height: "28px"}} title="Reload">
                        <span className="fas fa-sync-alt p-c p-button-icon-left"></span>
                    </button>
                </div>
            ) : this.state.filter ? <div className="p-inputgroup-addon position-absolute" style={{top: "-30px", right: 0}}>{filter}</div> : null;
            const h = <div className={this.state.headerClassName} style={_.merge({}, this.state.headerStyle, {width: "calc(100% - " + width + ")", minHeight: "2rem"})} {...attr}></div>;
            header = <div className="w-100 m-0 p-0" style={{position: "relative"}}>
                {h}
                <div className={"m-0 p-0 w-100 position-relative"}>{reload}</div>
                {filters}
            </div>;
        } else if (this.state.header) {
            header = <div className={this.state.headerClassName} style={this.state.headerStyle} {...attr}></div>;
        }
        return (
            <React.Fragment>
                <div className="m-0 p-0 text-left" style={{fontWeight: "normal"}}>
                    {f}
                    {header}
                </div>
                {action}
                {inlineEditor}
                {fileList}
                {fileUpload}
            </React.Fragment>
        );
    }

    private _footer(): JSX.Element | string {
        const f = GridHelper.indicatorGridContainer("Footer", true);
        const attr = {
            [DomAttribute.GRIDID]: this.state[GridIdKeyConstant],
            [DomAttribute.CONTAINER]: "footer",
            [DomAttribute.GRIDSEARCHCONTAINER]: this._elementId,
            [DomAttribute.GRIDROOT]: this.elementId + "-direct",
            [DomAttribute.GRIDLINKID]: this.state[GridLinkIdKeyConstant],
        };
        return (
            <div className="m-0 p-0 text-left" style={{"fontWeight": "normal"}}>
                {f}
                <div className={this.state.footerClassName} style={this.state.footerStyle} {...attr}></div>
            </div>
        );
    }

    private _bodyTemplate(data: any, info: any): React.ReactNode {
        if (info.field === GridSpecialColumn.CHECKBOX) {
            return null;
        }
        let attr2;
        const editable = this._columns[info.columnKey].editable;
        if (editable) {
            const type = this._columns[info.columnKey].type;
            if (type !== DataType.FILE) {
                attr2 = {
                    [DomAttribute.CONTAINER]: this._columns[Number(info.columnKey)].entityId,
                    [DomAttribute.GRIDEDITID]: this._columns[Number(info.columnKey)].entityId
                };
            }
        }
        if (!window[WindowKey.DESIGNMODE] && !window[WindowKey.VERSIONMODE]) {
            if (info.field === GridSpecialColumn.ACTION) {
                const attr = {
                    [DomAttribute.GRIDDIRECTPARENT]: info.rowIndex
                };
                const style = this.state.actionWidth ? {
                    style: {
                        width: this.state.actionWidth + "px",
                        margin: "auto auto"
                    }
                } : null;
                return <div className="w-100 text-center"><div {...attr} {...style}></div></div>;
            }
            if (this._reData === true) {
                let retValue;
                const value = this._makeValue(this._list[this.state.value[info.rowIndex]][info.field], this._columns[Number(info.columnKey)], info.rowIndex, this.state.value[info.rowIndex]);
                const context = (this._columns[info.columnKey].clickScope === "global") ? this.state.click : this._columns[info.columnKey].click;
                if (context) {
                    retValue = value && typeof value === "string" ?
                        <a tabIndex={0} className={(attr2 ? "___column " : "") + "w-100 h-100 m-0 d-block"} bf-data-index={info.columnKey}
                           onClick={this._onClick} onKeyDown={this._onEnter} onContextMenu={this._onContextMenu}
                           dangerouslySetInnerHTML={{__html: value}}></a> :
                        <a tabIndex={0} className={(attr2 ? "___column " : "") + "w-100 h-100 m-0 d-block"} bf-data-index={info.columnKey}
                           onClick={this._onClick} onKeyDown={this._onEnter} onContextMenu={this._onContextMenu}>{value}</a>;
                } else {
                    retValue = value && typeof value === "string" ?
                        <div className={(attr2 ? "___column " : "") + "w-100 h-100 m-0"} bf-data-index={info.columnKey}
                             onContextMenu={this._onContextMenu}
                             dangerouslySetInnerHTML={{__html: value}}></div> :
                        <div className={(attr2 ? "___column " : "") + "w-100 h-100 m-0"} bf-data-index={info.columnKey}
                             onContextMenu={this._onContextMenu}>{value}</div>;
                }
                if (!this._bindData[info.rowIndex]) {
                    this._bindData[info.rowIndex] = {};
                }
                if (attr2) {
                    retValue = (
                        <React.Fragment>
                            {retValue}
                            <div className="___edit m-0 p-0 w-100 h-100 d-none lds-application-fast lds-application-fade-in" {...attr2} onClick={this._onClick} onContextMenu={this._onInlineContextMenu}></div>
                        </React.Fragment>
                    );
                }
                this._bindData[info.rowIndex][info.columnKey] = retValue;
                return retValue;
            } else {
                return this._bindData[info.rowIndex][info.columnKey];
            }
        } else if (editable) {
            return <div className="m-0 p-0" {...attr2}></div>;
        }
        return null;
    }

    private _makeInlineEditComponents(item: any, index: number) {
        if (item.field === GridSpecialColumn.CHECKBOX) {
            return null;
        }
        if (this._columns[index].editable) {
            const type = this._columns[index].type;
            if (type !== DataType.FILE) {
                const attr = {
                    [DomAttribute.CONTAINER]: this._columns[index].entityId
                };
                return <div {...attr}></div>;
            }
        }
    }

    private async _sign(e: any): Promise<void> {
        let parent = e.target.parentElement;
        const target = e.target;
        parent.classList.add("p-0");
        parent.classList.add("text-center");
        parent = parent.parentElement;
        while (!parent.offsetHeight || this._startInlineEditor) {
            await FunctionHelper.timeout(0);
        }
        target.setAttribute("height", Math.max(parent.offsetHeight - 10, 20) + "px");
        target.setAttribute("width", "auto");
        target.classList.remove("position-absolute");
        target.style.visibility = "visible";
    }

    private _numberFormat(value: any, columns: GridTableColumnsInformation): any {
        let rValue = "";
        if (value || value === 0) {
            value = Number(value);
            if (!isNaN(value)) {
                let s;
                if (columns.format.separator === "locale") {
                    s = this._t;
                } else {
                    s = columns.format.separator;
                }
                if (columns.type === DataType.NUMBER && (columns.format.precision || columns.format.precision === 0)) {
                    value = value.toFixed(columns.format.precision);
                }
                if (s) {
                    const rv = String(value).split(".");
                    const d = (s === ".") ? "," : ".";
                    rValue = rv[0].replace(this._reg, s) + (rv[1] ? d + rv[1] : "");
                } else {
                    return value;
                }
            } else {
                rValue = value;
            }
        }
        return rValue;
    }

    private _valueTemplate(value: any, columns: GridTableColumnsInformation, orgValue: any, pk: string, rowIndex: number) {
        if (columns.template) {
            let [content, script] = FunctionHelper.gridTemplate(columns.template);
            if (script) {
                script = script.replace(/\{\s*orgValue\s*}/g, typeof orgValue === "object" ? JSON.stringify(orgValue, null, 2) : orgValue);
                script = script.replace(/\{\s*gridInfo\s*}/g, JSON.stringify({
                    alias: FormDataSchemaService.getProjectGroupFieldData(this.applicationId, this.state[GridIdKeyConstant], true).grid.alias,
                    linkId: this.state[GridLinkIdKeyConstant],
                    listId: this._elementId,
                    pk: pk,
                    rowIndex: rowIndex
                }, null, 2));
                script = script.replace(/\{\s*value\s*}/g, value);
                const rValue = script ? FunctionHelper.execute(script) : value;
                value = content.replace(/\{\s*value\s*}/g, rValue !== undefined ? rValue : "");
            } else {
                value = columns.template.replace(/\{\s*value\s*}/g, value !== undefined ? value : "");
            }
        }
        return value;
    }

    private _makeValue(value: any, columns: GridTableColumnsInformation, rowIndex: number, pk: string): any {
        let rValue = "";
        switch (columns.type) {
            case DataType.LOOKUP:
                return this._valueTemplate(value ? value.label || value.value : "", columns, value, pk, rowIndex);
            case DataType.LOOKUPARRAY:
                rValue = "";
                for (const k in value) {
                    if (value[k] && value[k].value) {
                        rValue += (value[k].label || value[k].value) + ", ";
                    }
                }
                return this._valueTemplate(rValue.replace(/, $/, ""), columns, value, pk, rowIndex);
            case DataType.DATE: case DataType.DATETIME: case DataType.TIME:
                return this._valueTemplate(value ? DateHelper.formatter(new Date(value), columns.format.view) : "", columns, value, pk, rowIndex);
            case DataType.UTCDATE: case DataType.UTCDATETIME: case DataType.UTCTIME:
                return this._valueTemplate(value ? DateHelper.formatter(new Date(DateHelper.convertUTCServerToFront(value)), columns.format.view) : "", columns, value, pk, rowIndex);
            case DataType.DATEARRAY:
            case DataType.UTCDATEARRAY:
                rValue = "";
                for (const k in value) {
                    if (value[k]) {
                        rValue += DateHelper.formatter(new Date(value[k]), columns.format.view) + ", ";
                    }
                }
                return this._valueTemplate(rValue.replace(/, $/, ""), columns, value, pk, rowIndex);
            case DataType.INTEGER: case DataType.NUMBER:
                rValue = this._numberFormat(value, columns);
                return this._valueTemplate(rValue, columns, value, pk, rowIndex);
            case DataType.INTEGERARRAY: case DataType.NUMBERARRAY:
                rValue = "";
                for (const k in value) {
                    if (value[k]) {
                        rValue += this._numberFormat(value[k], columns) + ", ";
                    }
                }
                return this._valueTemplate(rValue.replace(/, $/, ""), columns, value, pk, rowIndex);
            case DataType.USER:
                return value && value.name ? <UserUI
                    name={value.name}
                    email={value.email}
                    id={value.id}
                    showButton={value.email ? true : false}
                ></UserUI> : null;
            case DataType.SIGN:
                if (value) {
                    value = value.split ? value.split("@")[0] : value;
                    return <img src={value} className="m-0 p-0 position-absolute" style={{visibility: "hidden"}} onLoad={this._sign}/>;
                }
                break;
            case DataType.FILE:
                if (Array.isArray(value) && value.length || columns.editable) {
                    value = !value || !value.length ? [] : value;
                    const attr = {
                        [DomAttribute.GRIDID]: this.state[GridIdKeyConstant],
                        [DomAttribute.GRIDLINKID]: this.state[GridLinkIdKeyConstant],
                        [DomAttribute.GRIDDIRECTCONTAINER]: this._elementId
                    };
                    const file = value.length ? <a tabIndex={0} bf-data-value={columns.entityId + "-" + rowIndex} onClick={this._onOpenOverlay} onKeyDown={this._onOpenOverlay} className="bf-cursor-pointer">{value.length + (value.length < 2 ? " File" : " Files...")}</a> : <div bf-data-value={columns.entityId + "-" + rowIndex} onClick={this._onOpenOverlay} onKeyDown={this._onOpenOverlay}>0 File</div>;
                    return <React.Fragment>
                        {file}
                        <OverlayPanel
                            key={columns.entityId + "-" + rowIndex}
                            ref={this._setFileList}
                            showCloseIcon={true}
                            dismissable={false}
                            appendTo={DomHelper.getForOverLayDom()}
                            className={this.state.fileClassName}
                            style={this.state.fileStyle}
                        >
                            <div bf-data-value={columns.entityId + "-" + rowIndex} {...attr}>
                            </div>
                        </OverlayPanel>
                    </React.Fragment>;
                }
                break;
            case DataType.ANY:
                rValue = this._valueTemplate(typeof value === "object" ? JSON.stringify(value, null, 2) : value, columns, value, pk, rowIndex);
                break;
            case DataType.TRISTATE:
                rValue = this._valueTemplate(value || value === false || value === null ? value.toString() : "", columns, value, pk, rowIndex);
                break;
            default:
                rValue = this._valueTemplate(value || value === 0 || value === false ? value.toString() : "", columns, value, pk, rowIndex);
        }
        return rValue;
    }

    private _makeColumns(item: GridTableColumnsInformation, index: number): React.ReactNode {
        if (item.usable) {
            if (item.special) {
                const header = item.special === GridSpecialColumn.CHECKBOX ? "" : item.label || "Action";
                return <Column
                    key={item.special + "_" + index} columnKey={String(index)} field={item.special} header={header} body={this._bodyTemplate} sortable={false} frozen={item.frozen} selectionMode={item.special === GridSpecialColumn.CHECKBOX ? this.state.checkbox : null}
                    headerClassName={this.state.columnHeaderClassName} headerStyle={this.state.columnHeaderStyle}
                    bodyClassName={this.state.columnBodyClassName} bodyStyle={this.state.columnBodyStyle}
                ></Column>;
            } else {
                const s = FormDataSchemaService.getProjectDataSchemaFieldData(this.applicationId, item.entityId, true);
                return <Column
                    key={item.entityId + "_" + index} columnKey={String(index)} field={item.entityId} header={item.label || s.label || s.name} body={this._bodyTemplate} sortable={this.state.sortMode !== "none" && item.sortable} frozen={item.frozen}
                    headerClassName={this.state.columnHeaderClassName} headerStyle={this.state.columnHeaderStyle}
                    bodyClassName={this.state.columnBodyClassName} bodyStyle={this.state.columnBodyStyle}
                ></Column>;
            }
        } else {
            return null;
        }
    }

    private _makeFilter(): React.ReactNode {
        const attr = {
            applicationId: this.applicationId,
            formId: this.formId,
            [GridIdKeyConstant]: this.state[GridIdKeyConstant],
            [GridLinkIdKeyConstant]: this.state[GridLinkIdKeyConstant],
            containerElementId: StringHelper.elementId(this.elementId),
            forcedRerender: this._forcedFilter,
            filter: this._filterField,
            inline: true
        };
        this._forcedFilter = false;
        let fDom;
        const f = <Filter key={this.elementId + "_filter"} {...attr} onSearch={this.onSearch} onFilterError={this.state.cFilter ? this._onFilterError : null}/>;
        if (this.state.overlay) {
            const filterClassName = this.state.filter && this.state.filterClassName ? this.state.filterClassName : null;
            fDom = <OverlayPanel key={this.elementId + "_overlay_0"} ref={this._setFilterRef} showCloseIcon={true} dismissable={false} appendTo={DomHelper.getForOverLayDom()} className={"bf-bg-theme bf-text-theme"}>
                <div style={{minWidth: "300px"}}>
                    <div className={filterClassName} style={this.state.filterStyle}>{f}</div>
                </div>
            </OverlayPanel>;
        } else {
            const filterClassName = (this.state.filter && this.state.filterClassName ? this.state.filterClassName + " " : "") + "d-none";
            fDom = <div ref={this._setFilterRef} className={filterClassName} style={this.state.filterStyle}>{f}</div>;
        }
        return <React.Fragment>
            {fDom}
            <OverlayPanel key={this.elementId + "_overlay_1"} ref={this._setCFilterRef} onHide={this._onColumnFilter} showCloseIcon={true} dismissable={false} appendTo={DomHelper.getForOverLayDom()} className={"bf-bg-theme bf-text-theme"}>
                <div style={{width: "300px", minWidth: "300px", maxWidth: "300px"}}></div>
            </OverlayPanel>
        </React.Fragment>;
    }

    private _filterStructure(newState: State) {
        if (!Array.isArray(this._filterField)) {
            this._filterField = [];
            for (const i in newState.columns) {
                if (newState.columns[i] && newState.columns[i].entityId && newState.columns[i].filterable && newState.columns[i].filterOptions && newState.columns[i].filterOptions.length) {
                    this._filterField.push({
                        entityId: newState.columns[i].entityId,
                        type: newState.columns[i].type,
                        label: newState.columns[i].label,
                        filterFunc: newState.columns[i].filterFunc,
                        placeholder: newState.columns[i].filterHolder,
                        format: newState.columns[i].format,
                        options: newState.columns[i].filterOptions
                    });
                }
            }
            return this._filterField;
        }
        return this._filterField;
    }

    private _onFilterError(entityIdError: Array<string>) {
        GridHelper.errorFilter(this._th, entityIdError, this._columns).then();
    }

    private _makeFakeDom() {
        let s = this._fakeDom.length;
        let e = s;
        const iDom = Array.from(this._directDom.querySelectorAll(`.p-datatable-row`));
        for (let i = 0; i < this._listSize; i++) {
            if (this.state.action && !this._fakeDom[i]) {
                const fake = document.createElement("div");
                fake.setAttribute(DomAttribute.GRIDDIRECTCONTAINER, this._elementId);
                fake.setAttribute(DomAttribute.CONTAINER, "action_" + i);
                this._fakeDom[i] = fake;
                const inline = document.createElement("div");
                inline.setAttribute(DomAttribute.GRIDDIRECTCONTAINER, this._elementId);
                inline.setAttribute(DomAttribute.CONTAINER, "inlineAction_" + i);
                inline.classList.add("d-none");
                this._fakeInlineDom[i] = inline;
                e++;
            }
            iDom[i].setAttribute(DomAttribute.GRIDID, this.state[GridIdKeyConstant]);
            iDom[i].setAttribute(DomAttribute.GRIDDIRECTCONTAINER, this._elementId);
            iDom[i].setAttribute(DomAttribute.GRIDLINKID, this.state[GridLinkIdKeyConstant]);
            iDom[i].setAttribute(DomAttribute.GRIDID, this.state[GridIdKeyConstant]);
            iDom[i].setAttribute(DomAttribute.GRIDPK, this.state.value[i]);
            if (this.state.action) {
                const pDom = this._directDom.querySelector(`[${DomAttribute.GRIDDIRECTPARENT}="${i}"]`);
                if (pDom && this._fakeDom[i]) {
                    pDom.appendChild(this._fakeDom[i]);
                    pDom.appendChild(this._fakeInlineDom[i]);
                }
            }
            let cDom: HTMLElement;
            if (this.state.checkbox !== "none") {
                cDom = this.state.checkbox === "multiple" ? iDom[i].querySelector(`.p-selection-column > .p-checkbox > .p-hidden-accessible`) : iDom[i].querySelector(`.p-selection-column > .p-radiobutton > .p-hidden-accessible`);
                if (cDom) {
                    cDom.setAttribute(DomAttribute.GRIDCHECKBOX, this.state.value[i]);
                }
            }
            if (this.state[GridRetrieveKeyConstant]) {
                if (GridDataService.hasEpkFromTable(this.formId, iDom[i].firstChild as HTMLElement)) {
                    iDom[i].setAttribute("data-has-epk", "");
                    if (cDom) {
                        cDom.querySelector("input").disabled = true;
                        (cDom.parentElement.querySelector(".p-component") as HTMLElement).style.visibility = "hidden";
                    }
                } else {
                    iDom[i].removeAttribute("data-has-epk");
                    if (cDom) {
                        cDom.querySelector("input").disabled = false;
                        (cDom.parentElement.querySelector(".p-component") as HTMLElement).style.visibility = "visible";
                    }
                }
            }
        }
        if (this.state.action) {
            SubjectService.notificationSubject.next({
                applicationId: this.applicationId,
                formId: (this as any).___props.formId,
                elementId: this._elementId,
                type: NotificationSubjectType.GRIDREPEATCONTAINERRENDERING,
                value: {
                    start: s,
                    end: e,
                    dom: this._directDom
                }
            });
        }
    }

    private _removeFakeDom() {
        if (this._fakeDom.length) {
            for (let i = 0; i < this._fakeDom.length; i++) {
                if (this._fakeDom[i].parentElement) {
                    this._fakeDom[i].parentElement.removeChild(this._fakeDom[i]);
                    this._fakeInlineDom[i].parentElement.removeChild(this._fakeInlineDom[i]);
                } else {
                    break;
                }
            }
        }
    }

    private _makeSort(): Array<SortOption> {
        if (this.state.sortMode === "single") {
            return [{
                field: this.state.sortField,
                order: this.state.sortOrder as any
            }];
        } else if (this.state.sortMode === "multiple" && Array.isArray(this.state.multiSortMeta) && this.state.multiSortMeta.length) {
            const sorts = [];
            for (const k in this.state.multiSortMeta) {
                sorts.push({
                    field: this.state.multiSortMeta[k].field,
                    order: this.state.multiSortMeta[k].order === 1 ? "asc" : "desc"
                });
            }
            return sorts;
        }
        return null;
    }

    private _setTableRef(ref) {
        if (ref) {
            this._table = ref;
            const p = ref.container.querySelector(".p-datatable-wrapper");
            p.style.overflowX = "auto";
            this._directDom = p.querySelector("table>.p-datatable-tbody");
            this._directDom.setAttribute("id", this.elementId + "-direct");
            this._dWrapper = p;
            this._dHeader = ref.container.querySelector(".p-datatable-header");
            this._dFooter = ref.container.querySelector(".p-paginator");
            this._dPaginator = ref.container.querySelector(".p-datatable-footer");
            if (this.state.autoResize && !this._regResize) {
                if (DomHelper.modalLinkParentDom(this.parentDom)) {
                    ModalHandler.regOpenCallback(this._autoResize);
                } else {
                    this._autoResize(this.parentDom.parentElement, true);
                }
                this._regResize = true;
            }
            ModalHandler.regOpenCallback(this._overlay);
            if (DomHelper.modalLinkParentDom(this.parentDom)) {
                ModalHandler.regCloseCallback(this._overlay);
            }
            this.readyComponent();
        }
        this._th = GridHelper.inlineFilter(this.state.cFilter, this._dWrapper, this._filter, this._columns, this._onColumnFilter);
        this._initInlineFilter = true;
        if (!window[WindowKey.DESIGNMODE] && this.state.fixedHeader && this._th) {
            this._style = document.createElement("style");
            document.head.appendChild(this._style);
            GridHelper.fixedHeader(this._value, this._style, this.elementId, this._th, this._dWrapper, Number(this.state.fixedHeader), true).then();
        }
    }

    @EventResize()
    private _resizeListener(e?: Event) {
        if (!window[WindowKey.DESIGNMODE] && this.state.fixedHeader && this._th) {
            if (window.getSelection) {
                window.getSelection().removeAllRanges();
            } else if (document["selection"]) {
                document["selection"].empty();
            }
            GridHelper.fixedHeader(this._value, this._style, this.elementId, this._th, this._dWrapper, Number(this.state.fixedHeader), false).then();
        }
    }

    private _setFilterRef(ref: any) {
        if (ref) {
            this._filter = ref;
        }
    }

    private _setCFilterRef(ref: any) {
        if (ref) {
            this._cFilter = ref;
        }
    }

    private _setFileList(e: any) {
        if (e && e.container) {
            if (!this._fileList) {
                this._fileList = {};
            }
            this._fileList[e.container.querySelector("[bf-data-value]").getAttribute("bf-data-value")] = e;
        }
    }

    private _setFakeFileList(e: any) {
        if (e) {
            this._fakeFileList = e;
        }
    }

    private _setFakeFileUpload(e: any) {
        if (e) {
            this._fakeFileUpload = e;
        }
    }

    private _setFakeSign(e: any) {
        if (e) {
            this._fakeSign = e;
        }
    }

    private _setContextRef(e: any) {
        if (e) {
            this._context = e;
            this._contextContainer = e.container.querySelector("#" + this.elementId + "_context");
            this._contextContainer.parentElement.classList.add("pt-1");
            this._contextContainer.parentElement.classList.add("pr-1");
            this._contextContainer.parentElement.classList.add("pb-0");
            this._contextContainer.parentElement.classList.add("pl-1");
            this._removeContextList();
        }
    }

    private _setComponentRef(e: any) {
        if (e) {
            this._componentRef = e;
        }
    }

    private _callbackList() {
        let info = GridDataService.getGridInfoData(this.formId, this.state[GridIdKeyConstant], this.state[GridLinkIdKeyConstant], this._elementId);
        FormValidationService.regGridFirstData((this as any).___props, info);
        this._list = ObjectHelper.jsonCloneDeep(GridDataService.getGridListData(this.formId, this.state[GridIdKeyConstant], this.state[GridLinkIdKeyConstant], this._elementId));
        this._pageNo = info && info.pageNo ? info.pageNo : 1;
        let value = null;
        const child = FormDataSchemaService.getProjectGroupChildKeys(this.applicationId, this.state[GridIdKeyConstant]);
        const state = (FormStateService as any).___getReadonlyFormStateData(this.applicationId, (this as any).___props.parentFormId || (this as any).formId);
        if (this._list && Object.keys(this._list).length) {
            value = [];
            let i = 1;
            Reflect.ownKeys(this._list).forEach(
                (k: string) => {
                    if (i > this.state.rows) {
                        delete(this._list[k]);
                    } else {
                        value.push(k);
                        RelationShipDataService.doRelationshipOnGridTable(this.applicationId, this.formId, this.state[GridIdKeyConstant], this._list[k], child, state);
                    }
                    i++;
                }
            );
        }
        this._listSize = value && value.length ? value.length : 0;
        this._removeFakeDom();
        this._reData = true;
        ObjectHelper.purge(this._bindData);
        this._bindData = {};
        this._startInlineEditor = true;
        this.setState({
            pageNo: this._pageNo,
            totalRecords: info && info.totalCount ? info.totalCount : 0,
            value: value
        }, this._unload);
    }

    private _doUnload() {
        this._startInlineEditor = false;
    }

    private async _unload(): Promise<void> {
        this._makeFakeDom();
        BlockHandler.unload(this.elementId);
        if (this._hasEdit) {
            this._inlineEditor(null, null, true).then(this._doUnload);
        } else {
            this._startInlineEditor = false;
        }
        if (this._hasPk) {
            await FunctionHelper.timeout(300);
            this._hasPk = false;
        }
        this._resizeListener();
    }

    private _onReload(init?: any) {
        if (this._fromSort) {
            GridHelper.inlineFilter(this.state.cFilter, this._dWrapper, this._filter, this._columns, this._onColumnFilter);
            this._fromSort = false;
        }
        const forced = init && init.target ? true : false;
        this.setPage(this._pageNo, init === true ? true : false, true, null, forced).then();
    }

    private _onFilter(e?: any) {
        if (this._filter) {
            if (this._filter && this._filter.toggle) {
                this._overlay();
                this._filter.container.style.width = this.parentDom.offsetWidth + "px";
                this._filter.toggle(e);
            } else {
                const dNone = this._filter.classList.contains("d-none");
                this._overlay();
                if (dNone) {
                    this._filter.classList.remove("d-none");
                }
            }
        }
    }

    private _onColumnFilter(e?: any) {
        if (e && e.preventDefault) {
            e.preventDefault();
            // e.stopPropagation();
        }
        this._overlay(true);
        const index = e && e.target ? Number(e.target.getAttribute("bf-data-value")) : -1;
        const container = this._filter && this._filter.container ? this._filter.container : this._filter;
        if (index === -1 || this._preColumnFilterIndex === index) {
            if (index !== -1 && this._cFilter && this._cFilter.toggle) {
                this._cFilter.toggle(e);
            }
            const filter = this._cFilter.container.querySelector("[bf-data-value]");
            if (filter) {
                const entityId = filter.getAttribute("bf-data-value");
                filter.querySelector("[bf-data-button]").classList.add("d-none");
                container.querySelector(`[bf-data-parent="${entityId}"]`).appendChild(filter.parentElement.removeChild(filter));
            }
            this._preColumnFilterIndex = null;
        } else if (e && e.preventDefault) {
            this._preColumnFilterIndex = index;
            if (this._cFilter && this._cFilter.toggle) {
                const filter = container.querySelector(`[bf-data-value="${this._columns[this._preColumnFilterIndex].entityId}"]`);
                filter.querySelector("[bf-data-button]").classList.remove("d-none");
                this._cFilter.container.querySelector("div").appendChild(filter.parentElement.removeChild(filter));
                this._cFilter.toggle(e);
            }
        }
    }

    private _onSort(e: { sortField: string, sortOrder: number, multiSortMeta: any }, state?: State) {
        if (this.state.sortMode !== "none") {
            if (state) {
                if (state.columns && state.columns.length) {
                    const index = _.findIndex(state.columns, {defaultSort: true});
                    if (index > -1) {
                        const ds = state.columns[index].entityId;
                        if (ds) {
                            if (state.sortMode === "single") {
                                state.sortField = ds;
                            } else {
                                state.multiSortMeta = [{
                                    field: ds,
                                    order: state.sortOrder === "desc" ? -1 : 1
                                }];
                            }
                        }
                    }
                }
            } else if (this.state.sortMode === "single") {
                this._fromSort = true;
                this.setState({
                    sortField: e.sortField,
                    sortOrder: e.sortOrder === 1 ? "asc" : "desc"
                }, this._onReload);
            } else {
                const m = ObjectHelper.jsonCloneDeep(this.state.multiSortMeta);
                const index = _.findIndex(m, {field: e.sortField});
                if (index > -1) {
                    m[index].order = m[index].order === e.sortOrder ? e.sortOrder * -1 : e.sortOrder;
                    if (m.length > 1) {
                        if (m[index].order !== this._dSortOrder) {
                            m.splice(index, 1);
                        }
                    }
                    this._fromSort = true;
                    this.setState({
                        multiSortMeta: m
                    }, this._onReload);
                    return;
                }
                m.push({
                    field: e.sortField,
                    order: e.sortOrder
                });
                this._fromSort = true;
                this.setState({
                    multiSortMeta: m
                }, this._onReload);
            }
        }
    }

    private _onOpenOverlay(e: any) {
        if (this._fakeFileList || this._fakeFileUpload) {
            if (e.key && e.key !== "Enter") {
                return;
            }
            e.stopPropagation();
            e.preventDefault();
            const pk = DomHelper.getGridInformationFromDom(e.target, null).containerPk;
            if (e.altKey && this._hasEdit) {
                this._inlineEditor(this._inLinePk ? null : pk, true, true).then();
            }
            const id = e.target.getAttribute("bf-data-value") || e.target.parentElement.getAttribute("bf-data-value");
            const [entityId, index] = id.split("-");
            const fPk = DomHelper.getGridInformationFromDom(e.target, null).containerPk;
            if (e.target.classList.contains("d-none")) {
                e.target = e.target.parentElement.firstChild;
            }
            if ((!this._inLinePk || this._inLinePk !== fPk) && e.target.tagName.toLowerCase() !== "a") {
                this._fileList[id].hide(e);
                return;
            } else {
                this._overlay();
                this._fileList[id].toggle(e);
            }
            const d = this._fileList[id].container.querySelector(`[${DomAttribute.GRIDID}]`);
            if (this._fakeFileUpload) {
                this._fakeFileUpload.classList.remove("d-none");
                if (this._inLinePk === pk) {
                    this._fakeFileUpload.setAttribute(DomAttribute.GRIDPK, this._inLinePk);
                    try {
                        d.appendChild(this._fakeFileUpload.parentElement.removeChild(this._fakeFileUpload));
                    } catch (e) {
                        d.appendChild(this._fakeFileUpload);
                    }
                } else {
                    try {
                        this._fakeFileUpload.parentElement.removeChild(this._fakeFileUpload);
                    } catch (e) {
                    }
                }
            }
            if (this._fakeFileList) {
                this._fakeFileList.classList.remove("d-none");
                try {
                    d.appendChild(this._fakeFileList.parentElement.removeChild(this._fakeFileList));
                } catch (e) {
                }
            }
            d.setAttribute(DomAttribute.GRIDPK, this._inLinePk);
            for (const key in this._fileList) {
                if (key !== id) {
                    this._fileList[key].hide(null);
                }
            }
            if (this._preFileList !== entityId + "-" + index) {
                this._preFileList = entityId + "-" + index;
                SubjectService.gridSubject.next({
                    applicationId: this.applicationId,
                    formId: this.formId,
                    containerElementId: this.elementId,
                    type: GridSubjectType.FILELIST,
                    value: {
                        entityId: entityId,
                        list: ObjectHelper.jsonCloneDeep(this._list[this.state.value[index]][entityId]),
                        pk: pk,
                        edit: this._inLinePk === pk
                    }
                });
            }
        }
    }

    private async _highlight(): Promise<void> {
        await FunctionHelper.timeout();
        const dom: Array<HTMLInputElement> = Array.from(this._directDom.querySelectorAll(`[${DomAttribute.GRIDCHECKBOX}]`));
        try {
            for (const k in dom) {
                if (dom[k].parentElement.parentElement.parentElement.classList.contains("p-highlight")) {
                    dom[k].querySelector(`input[type="checkbox"]`).setAttribute("checked", "");
                } else {
                    dom[k].querySelector(`input[type="checkbox"]`).removeAttribute("checked");
                }
            }
        } catch (e) {
        }
    }

    private _onSelectionChange(e: any) {
        this.setState({
            selection: e.value
        });
        this._highlight().then();
    }

    private _onRowSelect(e: { originalEvent: Event, data: any, type: string }) {
        if ((this._altKey || (e.originalEvent as any).altKey) && this._hasEdit) {
            let no = false;
            let target = (e.originalEvent as any).target;
            while (target && !target.hasAttribute(DomAttribute.GRIDID)) {
                if (target.hasAttribute(DomAttribute.GRIDDIRECTPARENT)) {
                    no = true;
                }
                target = target.parentElement;
            }
            if (!no && target) {
                this._altKey = false;
                const pk = DomHelper.getGridInformationFromDom((e.originalEvent as any).target, null).containerPk;
                this._inlineEditor(pk !== this._inLinePk ? pk : null, true).then();
            }
        }
        this._highlight().then();
        if (this.state.selectionAction) {
            if (this.state.selectionAction.state) {
                this.emitFormState(this.state.selectionAction.state, (e.originalEvent as any).target);
            }
            if (this.state.selectionAction.action) {
                GridActionService.callAction(this.applicationId, this.formId, this.state.selectionAction.action, (e.originalEvent as any).target, (this as any).___props);
            }
        }
    }

    private _onRowUnselect(e: { originalEvent: Event, data: any, type: string }) {
        this._highlight().then();
        if (this.state.deselectionAction) {
            if (this.state.deselectionAction.state) {
                this.emitFormState(this.state.deselectionAction.state, (e.originalEvent as any).target);
            }
            if (this.state.deselectionAction.action) {
                GridActionService.callAction(this.applicationId, this.formId, this.state.deselectionAction.action, (e.originalEvent as any).target, (this as any).___props);
            }
        }
    }

    private _onEnter(e: any) {
        if (e.key === "Enter") {
            e.target.click();
        }
    }

    private _onClick(e: any) {
        if (!e.altKey && this._inLinePk) {
            const pk = DomHelper.getGridInformationFromDom(e.target, null).containerPk;
            if (!pk || this._inLinePk === pk) {
                return;
            }
        }
        this._onContextClick(e, "click");
        this._altKey = e.altKey;
        this._inLineTarget = e.target.parentElement;
        this._inLineTarget.parentElement.click();
    }

    private _onContextMenu(e: any) {
        const pk = DomHelper.getGridInformationFromDom(e.target, null).containerPk;
        if (pk && pk === this._inLinePk) {
            this._onInlineContextMenu(e);
        } else {
            this._onContextClick(e, "context");
        }
    }

    private _onInlineContextMenu(e: any) {
        ContextHelper.onInlineAction(e.target, e, this.applicationId, this.formId, this._context, this._contextList, this.state.inlineContext, this._contextContainer, this._overlay, (this as any).___props);
    }

    private _onContextClick (e: any, mode: string) {
        if (e.target === this._inLineTarget || this.state.action && e.altKey && mode === "click") {
            this._altKey = false;
            this._inLineTarget = null;
            return;
        }
        let target = e.target;
        while (target && !target.hasAttribute("bf-data-index")) {
            target = target.parentElement;
            if (!target || !target.hasAttribute || target.tagName.toLowerCase() === "body") {
                return;
            }
        }
        if (target.innerHTML) {
            const index = Number(target.getAttribute("bf-data-index"));
            ContextHelper.onAction(target, e, mode, this.applicationId, this.formId, this._columns, index, this._context, this._contextList, this.state, this._contextContainer, this._overlay, (this as any).___props);
        }
    }

    private _autoResize(dom: HTMLElement, forced?: boolean) {
        const modal = DomHelper.getModalContentDomFromDom(this.parentDom);
        if (dom && (forced || (modal && dom === modal.querySelector(`[${DomAttribute.MODALBODY}]`)))) {
            const ht = dom.offsetHeight;
            if (ht && ht !== this._offsetHeight) {
                dom.style.overflowY = "hidden";
                this._offsetHeight = ht;
                if (this._dWrapper) {
                    let ah = (this._dHeader ? this._dHeader.clientHeight : 0) + (this._dPaginator ? this._dPaginator.clientHeight : 0) + (this._dFooter ? this._dFooter.clientHeight : 0);
                    this._dWrapper.style.height = (ht - ah - 10) + "px";
                    this._dWrapper.style.overflowY = "auto";
                }
            }
        }
    }

    private _overlay(cFilter?: boolean) {
        this._preFileList = null;
        if (!cFilter) {
            this._preColumnFilterIndex = null;
            if (this._cFilter && this._cFilter.hide) {
                this._cFilter.hide(null);
            }
        }
        if (this._filter && this._filter.hide) {
            this._filter.hide(null);
        } else if (this._filter) {
            this._filter.classList.add("d-none");
        }
        if (this._context && this._context.hide) {
            this._context.hide(null);
        }
        for (const key in this._fileList) {
            this._fileList[key].hide(null);
        }
    }

    private _removeContextList() {
        for (const k in this._contextList) {
            for (const l in this._contextList[k]) {
                DomHelper.purge(this._contextList[k][l]);
                this._contextList[k][l] = null;
            }
        }
    }

    private _inlineEditorFocus() {
        const dom = this._table.container.querySelector(`[${DomAttribute.GRIDPK}="${this._inLinePk}"]`);
        if (!dom.classList.contains("p-highlight")) {
            dom.click();
        }
    }

    private async _inlineEditor(pk?: string, sync?: boolean, noSave?: boolean): Promise<void> {
        if (this._hasEdit) {
            if (!sync) {
                await FunctionHelper.timeout();
            }
            const save = !noSave && this._inLinePk && this._inLinePk !== pk && !this._nextPk && !this._savedAuto;
            if (save) {
                BlockHandler.load(this.elementId, this.parentDom);
                let func = (result) => {
                    BlockHandler.unload(this.elementId);
                    if (result) {
                        this._nextPk = pk || "_self";
                        this._savedInlinePk = true;
                        this._onReload();
                    } else {
                        this._inlineEditor(pk, sync, true);
                    }
                    if (abort) {
                        (abort as any).__proto__ = null;
                        abort = null;
                    }
                    (func as any).__proto__ = null;
                    func = null;
                };
                let abort = (result) => {
                    BlockHandler.unload(this.elementId);
                    if (!result) {
                        this._inlineEditor(pk, sync, true);
                    } else {
                        this._inlineEditorFocus();
                    }
                    if (func) {
                        (func as any).__proto__ = null;
                        func = null;
                    }
                    (abort as any).__proto__ = null;
                    (abort as any).__proto__ = null;
                };
                GridActionService.runUpdate(this.applicationId, this.formId, this.state[GridIdKeyConstant], this.state[GridLinkIdKeyConstant], this._elementId, func, abort, this._directDom, false, true);
                return;
            }
            this._savedAuto = false;
            if (!pk && this._nextPk) {
                pk = this._nextPk !== "_self" ? this._nextPk : null;
                this._nextPk = null;
            }
            if (!this._components) {
                this._components = {};
                const c: Array<HTMLElement> = Array.from(this._componentRef.querySelectorAll(`[${DomAttribute.ENTITYID}]`));
                if (c && c.length) {
                    for (let i = 0; i < c.length; i++) {
                        const rc = c[i].parentElement;
                        this._components[c[i].getAttribute(DomAttribute.ENTITYID)] = rc.parentElement.removeChild(rc);
                    }
                }
            }
            this._overlay();
            if (this._inLinePk) {
                const dom = this._table.container.querySelector(`[${DomAttribute.GRIDPK}="${this._inLinePk}"]`) || this._inLinePkDom;
                if (dom) {
                    FormValidationService.resetValidation(dom);
                    const doms: Array<HTMLElement> = Array.from(dom.querySelectorAll(`[${DomAttribute.GRIDDIRECTPARENT}]>[${DomAttribute.CONTAINER}]`));
                    if (doms.length) {
                        doms[0].classList.remove("d-none");
                        doms[1].classList.add("d-none");
                    }
                    const columns: Array<HTMLElement> = Array.from(dom.querySelectorAll(".___column"));
                    for (let i = 0; i < columns.length; i++) {
                        columns[i].classList.add("d-block");
                        columns[i].classList.remove("d-none");
                    }
                    const edits: Array<HTMLElement> = Array.from(dom.querySelectorAll(".___edit"));
                    for (let i = 0; i < edits.length; i++) {
                        edits[i].classList.add("d-none");
                        const c = edits[i].querySelector(`[${DomAttribute.ENTITYID}]`);
                        if (c) {
                            const eId = c.getAttribute(DomAttribute.ENTITYID);
                            this._components[eId].parentElement.removeChild(this._components[eId]);
                        }
                    }
                }
                this._inLinePk = null;
            }
            this._inLinePkDom = null;
            if (pk) {
                const dom = this._table.container.querySelector(`[${DomAttribute.GRIDPK}="${pk}"]`);
                if (dom) {
                    this._inLinePkDom = dom;
                    const doms: Array<HTMLElement> = Array.from(dom.querySelectorAll(`[${DomAttribute.GRIDDIRECTPARENT}]>[${DomAttribute.CONTAINER}]`));
                    if (doms.length) {
                        doms[0].classList.add("d-none");
                        doms[1].classList.remove("d-none");
                    }
                    const edits: Array<HTMLElement> = Array.from(dom.querySelectorAll(".___edit"));
                    for (let i = 0; i < edits.length; i++) {
                        edits[i].classList.remove("d-none");
                        const eId = edits[i].getAttribute(DomAttribute.CONTAINER);
                        if (this._components[eId]) {
                            edits[i].appendChild(this._components[eId]);
                            if (BrowserHelper.isIE11()) {
                                edits[i].parentElement.appendChild(edits[i].parentElement.removeChild(edits[i]));
                            }
                        } else if (!edits[i].innerHTML) {
                            edits[i].innerHTML = "&nbsp;";
                        }
                    }
                    const columns: Array<HTMLElement> = Array.from(dom.querySelectorAll(".___column"));
                    for (let i = 0; i < columns.length; i++) {
                        columns[i].classList.remove("d-block");
                        columns[i].classList.add("d-none");
                    }
                    if (!dom.classList.contains("p-highlight")) {
                        dom.click();
                    }
                }
                this._inLinePk = pk;
            }
            SubjectService.gridSubject.next({
                applicationId: this.applicationId,
                formId: this.formId,
                type: GridSubjectType.CHANGEPK,
                containerElementId: this._elementId,
                value: CallGridAction.EDIT,
                pk: pk
            });
        }
    }

    // Inner Link
    async setPage(pageNo: number, init?: boolean, reload?: boolean, searchId?: string, forced?: boolean): Promise<void> {
        this._searchId = searchId;
        if (!window[WindowKey.DESIGNMODE] && !window[WindowKey.VERSIONMODE] && pageNo && (forced || filter || reload || this._pageNo !== pageNo)) {
            await FunctionHelper.timeout();
            BlockHandler.load(this.elementId, this.parentDom);
            const sort = this._makeSort();
            let func = (result) => {
                if (result) {
                    this._savedAuto = true;
                }
                if (func) {
                    if (this._hasEdit) {
                        this._altKey = false;
                        this._inLineTarget = null;
                    }
                    this._overlay();
                    GridDataService.getList(this.applicationId, this.formId, this.state[GridIdKeyConstant], this.state[GridLinkIdKeyConstant], this._elementId, sort, this._filters, pageNo === -1 ? 1 : pageNo, this.state.rows, init, this._callbackList, searchId, forced ? null : this._clientPagingSize, pageNo === -1);
                    if (abort) {
                        (abort as any).__proto__ = null;
                        abort = null;
                    }
                    (func as any).__proto__ = null;
                    func = null;
                }
            };
            let abort = (result) => {
                BlockHandler.unload(this.elementId);
                if (result) {
                    this._inlineEditorFocus();
                }
                if (func) {
                    (func as any).__proto__ = null;
                    func = null;
                }
                (abort as any).__proto__ = null;
                (abort as any).__proto__ = null;
            };
            if (!init && this.state[GridAutoSaveKeyConstant] && !this._savedInlinePk && pageNo !== -1) {
                GridActionService.runUpdate(this.applicationId, this.formId, this.state[GridIdKeyConstant], this.state[GridLinkIdKeyConstant], this._elementId, func, abort, this._directDom, false, this.state[GridValidationKeyConstant]);
            } else {
                func(true);
            }
            this._savedInlinePk = false;
        }
    }

    // Outer Link
    onPage(e: { first: number, rows: number, page: number, pageCount: number }) {
        const page = e.page + 1;
        if (page !== this._pageNo) {
            this.setPage(page).then();
        }
    }
}
